import { UserGroup } from "admin/types/interfaces/user";
import queryString from "query-string";
import { SWRConfiguration } from "swr";
import { useV1List } from "~/hooks/useV1List";
import { ACCESS_CONTROLLER_V1 } from "~/utils/accessController";

const useGroups = (
  {
    searchQuery,
    enabled = true,
    limit,
  }: { searchQuery?: string; enabled?: boolean; limit?: number } = {},
  options?: SWRConfiguration
) => {
  const qs = queryString.stringify({ ...(searchQuery && { q: searchQuery }) });
  const url = enabled ? `${ACCESS_CONTROLLER_V1}/user-tags${qs ? `?${qs}` : ""}` : null;
  return useV1List<UserGroup>(url, {
    ...options,
    ...(limit !== undefined && { pageLimit: limit }),
  });
};

export default useGroups;
